import 'moment/locale/ru';

import { ApplicationError } from '@/shared/ui/application-error';
import { NotificationsWithClear } from '@/shared/ui/clear-notifications';
import { useAppColorScheme } from '@/shared/lib/hooks/use-app-color-scheme';
import i18n from '@/shared/config/i18n';
import {
  createTheme,
  type CSSVariablesResolver,
  MantineProvider,
  MantineProviderProps,
} from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import * as Sentry from '@sentry/react';
import { I18nextProvider } from 'react-i18next';
import { mantineTheme, useThemeStore } from '@/mantineTheme';
import {
  CodeHighlightAdapterProvider,
  createShikiAdapter,
} from '@mantine/code-highlight';

import '@/styles/index.css';

async function loadShiki() {
  const { createHighlighter } = await import('shiki');
  const shiki = await createHighlighter({
    langs: ['tsx', 'scss', 'html', 'bash', 'json', 'jinja', 'python', 'log'],
    // You can load supported themes here
    themes: [],
  });

  return shiki;
}

const shikiAdapter = createShikiAdapter(loadShiki);

export const resolver: CSSVariablesResolver = (theme) => ({
  variables: {
    // ...Object.keys(theme.other.radius).reduce((acc, item) => {
    //   acc[`--mantine-radius-${item}`] = theme.other.radius[item];
    //   return acc;
    // }, {}),
  },
  light: {
    '--code-background': theme.other.codeBackgroundLight,
  },
  dark: {
    '--code-background': theme.other.codeBackgroundDark,
  },
});
export const AppProviders = ({
  children,
  env,
}: {
  children: React.ReactNode;
  env?: MantineProviderProps['env'];
}) => {
  const { defaultRadius, primaryColor, primaryShade } = useThemeStore(
    ({ defaultRadius, primaryShade, primaryColor }) => ({
      defaultRadius,
      primaryColor,
      primaryShade,
    }),
  );

  const colorScheme = useAppColorScheme();

  return (
    <I18nextProvider i18n={i18n}>
      <MantineProvider
        forceColorScheme={colorScheme}
        theme={createTheme(
          mantineTheme({
            defaultRadius,
            primaryColor,
            primaryShade,
            colorScheme,
          }),
        )}
        cssVariablesResolver={resolver}
        env={env}
      >
        <NotificationsWithClear />
        <CodeHighlightAdapterProvider adapter={shikiAdapter}>
          <Sentry.ErrorBoundary
            fallback={ApplicationError}
            onError={(error) => console.error('BOUNDARY CAUGHT:', error)}
          >
            <ModalsProvider>
              <DatesProvider settings={{ locale: i18n.language }}>
                {children}
              </DatesProvider>
            </ModalsProvider>
          </Sentry.ErrorBoundary>
        </CodeHighlightAdapterProvider>
      </MantineProvider>
    </I18nextProvider>
  );
};